module.exports = __webpack_public_path__ + "static/media/frontlogo.47e36779.png";